import React from 'react';
import { Plant } from '../types';

type GlyphPlant = Pick<Plant, 'emoji' | 'name'> & { image?: string };

/**
 * Renders a plant's icon: an image when one is provided (for plants with no
 * good emoji, e.g. radish), otherwise the emoji character. The image is sized
 * at 1em so it scales exactly like the surrounding emoji text.
 */
export function plantGlyph(plant: GlyphPlant): React.ReactNode {
  if (plant.image) {
    return (
      <img className="plant-glyph" src={plant.image} alt="" aria-hidden="true" draggable={false} />
    );
  }
  return plant.emoji;
}
